enum ProcedureType {
  GRID = 'GRID',
  NORMAL = 'NORMAL',
  MULTIRECORD = 'MULTIRECORD',
  PERMANENT_MULTIRECORD = 'PERMANENT_MULTIRECORD',
}

export default ProcedureType;
